package dev.maiklutz.ready4radio.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.*

private data class Contact(
    val name: String,
    val email: String,
    val street: String,
    val number: String,
    val zipcode: String,
    val city: String,
    val country: String,
)

private val contact = Contact(
    name = "Maik Lutz",
    email = "contact@maiklutz.de",
    street = "Siegelsdorfer Str.",
    number = "34",
    zipcode = "90431",
    city = "Nürnberg",
    country = "Deutschland",
)

private const val IMPRESSUM_CSS = """
:root {
    --bg-dark: #070c14;
    --text-main: #ffffff;
    --text-muted: rgba(255, 255, 255, 0.65);
    --accent-orange: #f59e0b;
    --accent-cyan: #38bdf8;
    --glass-bg: rgba(255, 255, 255, 0.04);
    --glass-border: rgba(255, 255, 255, 0.12);
    --frame-border: rgba(255, 255, 255, 0.18);
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background-color: var(--bg-dark);
    color: var(--text-main);
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
}

.bg-glow {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: 
        radial-gradient(circle at 75% 60%, rgba(14, 116, 144, 0.22) 0%, transparent 55%),
        radial-gradient(circle at 25% 30%, rgba(15, 23, 42, 0.85) 0%, transparent 65%),
        linear-gradient(180deg, #050a10 0%, #0a1420 50%, #050a10 100%);
    z-index: -2;
}

.bg-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-image: radial-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 0);
    background-size: 32px 32px;
    z-index: -1;
}

.app-frame {
    margin: 48px;
    min-height: calc(100vh - 96px);
    border: 1px solid var(--frame-border);
    border-radius: 28px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 40px 60px;
    z-index: 10;
    background: rgba(255, 255, 255, 0.01);
    box-shadow: inset 0 0 50px rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(10px);
}

header.header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 20px;
}

.logo {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.5px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    text-decoration: none;
    flex-shrink: 0;
}

.logo-icon {
    width: 26px;
    height: 26px;
    background: linear-gradient(135deg, #38bdf8, #0284c7);
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
}

.back-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    padding: 8px 18px;
    border-radius: 12px;
    text-decoration: none;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s;
}

.back-link:hover {
    background: #fff;
    color: #000;
    transform: translateY(-2px);
    border-color: #fff;
}

.impressum-content {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 40px 0;
    flex-grow: 1;
}

.impressum-title-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.impressum-title {
    font-size: 54px;
    font-weight: 800;
    line-height: 1.1;
    letter-spacing: -1.5px;
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.85) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.impressum-subtitle {
    font-size: 15px;
    color: var(--text-muted);
}

.impressum-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 24px;
}

.glass-card {
    background: var(--glass-bg);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    border: 1px solid var(--glass-border);
    border-radius: 20px;
    padding: 28px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.glass-card-full {
    grid-column: 1 / -1;
}

.card-heading {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding-bottom: 10px;
}

.card-heading-icon {
    font-size: 18px;
    color: var(--accent-orange);
}

.card-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-size: 14px;
    line-height: 1.6;
    color: var(--text-muted);
}

.card-body strong {
    color: #ffffff;
}

.card-body a {
    color: var(--accent-cyan);
    text-decoration: none;
    word-break: break-all;
}

.card-body a:hover {
    text-decoration: underline;
}

.card-body p {
    margin-bottom: 4px;
}

footer {
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: var(--text-muted);
    width: 100%;
}

footer a {
    color: var(--text-muted);
    text-decoration: none;
    margin-left: 20px;
    transition: color 0.2s;
}

footer a:hover {
    color: #fff;
}

@media (max-width: 1180px) {
    .app-frame {
        padding: 30px 40px;
    }
}

@media (max-width: 968px) {
    .app-frame {
        margin: 16px;
        padding: 25px;
        border-radius: 16px;
        min-height: auto;
    }
    .impressum-title {
        font-size: 38px;
    }
    .impressum-grid {
        grid-template-columns: 1fr;
    }
    footer {
        flex-direction: column;
        gap: 12px;
        text-align: center;
    }
    footer a {
        margin: 0 10px;
    }
}
"""

@Page("impressum")
@Composable
fun ImpressumPage() {
    LaunchedEffect(Unit) {
        document.title = "Impressum — RadioPrepared"
        val existingStyle = document.getElementById("impressum-style")
        if (existingStyle == null) {
            val styleElement = document.createElement("style")
            styleElement.id = "impressum-style"
            styleElement.textContent = IMPRESSUM_CSS
            document.head?.appendChild(styleElement)
        }
    }

    Div(attrs = { classes("bg-glow") })
    Div(attrs = { classes("bg-overlay") })

    Div(attrs = { classes("app-frame") }) {
        // Header
        Header(attrs = { classes("header-flex") }) {
            A(href = "/", attrs = { classes("logo") }) {
                Div(attrs = { classes("logo-icon") }) {
                    Text("✈")
                }
                Text("RadioPrepared")
            }

            A(href = "/", attrs = { classes("back-link") }) {
                Text("← Zurück zur Startseite")
            }
        }

        // Main Content
        Main(attrs = { classes("impressum-content") }) {
            Div(attrs = { classes("impressum-title-section") }) {
                H1(attrs = { classes("impressum-title") }) {
                    Text("Impressum")
                }
                P(attrs = { classes("impressum-subtitle") }) {
                    Text("Angaben und rechtliche Informationen gemäß § 5 Digitale-Dienste-Gesetz (DDG) sowie § 18 Abs. 2 Medienstaatsvertrag (MStV)")
                }
            }

            Div(attrs = { classes("impressum-grid") }) {
                // Card 1: Dienstanbieter & Betreiber
                Div(attrs = { classes("glass-card") }) {
                    Div(attrs = { classes("card-heading") }) {
                        Span(attrs = { classes("card-heading-icon") }) { Text("👤") }
                        Text("Angaben gemäß § 5 DDG")
                    }
                    Div(attrs = { classes("card-body") }) {
                        P {
                            B { Text("Dienstanbieter / Betreiber:") }
                            Br()
                            Text(contact.name)
                        }
                        P {
                            B { Text("Anschrift:") }
                            Br()
                            Text(contact.name)
                            Br()
                            Text("${contact.street} ${contact.number}")
                            Br()
                            Text("${contact.zipcode} ${contact.city}")
                            Br()
                            Text(contact.country)
                        }
                    }
                }

                // Card 2: Kontakt & Verantwortlicher
                Div(attrs = { classes("glass-card") }) {
                    Div(attrs = { classes("card-heading") }) {
                        Span(attrs = { classes("card-heading-icon") }) { Text("📬") }
                        Text("Kontakt & Redaktion")
                    }
                    Div(attrs = { classes("card-body") }) {
                        P {
                            B { Text("Kontakt:") }
                            Br()
                            Text("E-Mail: ")
                            A(href = "mailto:${contact.email}") { Text(contact.email) }
                        }
                        P {
                            B { Text("Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:") }
                            Br()
                            Text(contact.name)
                            Br()
                            Text("${contact.street} ${contact.number}")
                            Br()
                            Text("${contact.zipcode} ${contact.city}")
                        }
                    }
                }

                // Card 3: Streitschlichtung
                Div(attrs = { classes("glass-card", "glass-card-full") }) {
                    Div(attrs = { classes("card-heading") }) {
                        Span(attrs = { classes("card-heading-icon") }) { Text("⚖️") }
                        Text("Streitschlichtung")
                    }
                    Div(attrs = { classes("card-body") }) {
                        P {
                            B { Text("EU-Streitschlichtung:") }
                            Br()
                            Text("Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: ")
                            A(
                                href = "https://ec.europa.eu/consumers/odr/",
                                attrs = {
                                    attr("target", "_blank")
                                    attr("rel", "noopener noreferrer")
                                }
                            ) {
                                Text("https://ec.europa.eu/consumers/odr/")
                            }
                            Br()
                            Text("Unsere E-Mail-Adresse finden Sie oben im Impressum.")
                        }
                        P {
                            B { Text("Verbraucherstreitbeilegung / Universalschlichtungsstelle:") }
                            Br()
                            Text("Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.")
                        }
                    }
                }

                // Card 4: Haftungsausschluss & Urheberrecht
                Div(attrs = { classes("glass-card", "glass-card-full") }) {
                    Div(attrs = { classes("card-heading") }) {
                        Span(attrs = { classes("card-heading-icon") }) { Text("🛡️") }
                        Text("Haftungsausschluss & Urheberrecht")
                    }
                    Div(attrs = { classes("card-body") }) {
                        P {
                            B { Text("Haftung für Inhalte:") }
                            Br()
                            Text("Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.")
                        }
                        P {
                            B { Text("Haftung für Links:") }
                            Br()
                            Text("Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.")
                        }
                        P {
                            B { Text("Urheberrecht:") }
                            Br()
                            Text("Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.")
                        }
                    }
                }
            }
        }

        // Footer
        Footer {
            Div { Text("© 2026 RadioPrepared — Von Piloten für Piloten.") }
            Div {
                A(href = "/") { Text("Startseite") }
                A(href = "/impressum") { Text("Impressum") }
                A(
                    href = "https://maiklutz.de/DatenschutzRadioPrepared.html",
                    attrs = {
                        attr("target", "_blank")
                        attr("rel", "noopener noreferrer")
                    }
                ) {
                    Text("Datenschutz")
                }
            }
        }
    }
}
